// eslint-disable-next-line no-unused-vars
import request from '@/service/http'

export function searchList (data) {
  return request({
    url: '/api/stuTrainLesson/searchList',
    method: 'post',
    data,
  })
}

export function searchInit (classId) {
    return request({
      url: '/api/stuTrainLesson/searchInit',
      method: 'post',
      params: {classId},
    })
}
export function searchCoursesList (classId) {
  return request({
    url: '/api/stuTrainLesson/searchCoursesList',
    method: 'post',
    params: {classId},
  })
}
export function courseDetail (classId,courseId) {
  return request({
    url: '/api/stuTrainLesson/courseDetail',
    method: 'post',
    params: {classId,courseId},
  })
}

export function trainLessonDetail (classId,lessonId,userInfoId) {
  return request({
    url: '/api/stuTrainLesson/trainLessonDetail',
    method: 'post',
    params: {classId,lessonId,userInfoId},
  })
}

export function trainLessonFileSave (data) {
  return request({
    url: '/api/stuTrainLesson/trainLessonSave',
    method: 'post',
    data,
  })
}

export function lessonFileDetail (classId,lessonFileId,userInfoId) {
  return request({
    url: '/api/stuTrainLesson/trainLessonFileDetail',
    method: 'post',
    params: {classId,lessonFileId,userInfoId},
  })
}


